import { accessTokenService } from '@zeus/react-common/lib/business/service/token/access-token-service'
import { tokenService } from '@zeus/react-common/lib/business/service/token-service'
import React, { createContext, useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { logger } from 'src/util/logger'

export type AppData = {
  isLoading: boolean
  isLoggedIn: boolean
  invitationCode: string | null
}

export const SessionContext = createContext<AppData>({} as AppData)

export const AppContextProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const [isLoading, setIsLoading] = useState(true)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [invitationCode, setInvitationCode] = useState<string | null>(null)

  const checkIfLoggedIn = useCallback(async (): Promise<void> => {
    const hasAccessToken = await tokenService.hasAccessToken()
    setIsLoggedIn(hasAccessToken)
  }, [])

  const init = useCallback(async (): Promise<void> => {
    await checkIfLoggedIn()
    setIsLoading(false)
  }, [])

  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const invitationCodeFromUrl = params.get('invitation-code')

  useEffect(() => {
    if (invitationCodeFromUrl) {
      setInvitationCode(invitationCodeFromUrl)
    }
  }, [invitationCodeFromUrl])

  useEffect(() => {
    init().catch((err) => logger().error(err))
  }, [init])

  useEffect(() => {
    const subscription = accessTokenService.onChange(async () => {
      checkIfLoggedIn().catch((err) => logger().error(err))
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [checkIfLoggedIn])

  return <SessionContext.Provider value={{ isLoggedIn, isLoading, invitationCode }}>{children}</SessionContext.Provider>
}
